"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var width = _a.width;
            return ({
                position: 'relative',
                width: width,
            });
        },
        icon: {
            position: 'absolute',
            cursor: 'pointer',
            right: 0,
            top: 0,
            padding: theme.spacing(1),
            zIndex: 3,
        },
        image: function (_a) {
            var height = _a.height, width = _a.width;
            return ({
                width: width,
                height: height,
                objectFit: 'cover',
            });
        },
    });
});
